import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import '../EstudiosPerfiles';
import Popup from 'devextreme-react/popup';
import { useApiConfiguration } from '../../../api/api.configuration';
import { useScreenSize } from '../../../utils/media-query';
import DataGrid, { Column, Button as Butt, Editing, Item as Items, KeyboardNavigation, Paging, Scrolling, Sorting, StateStoring, Selection, FilterRow } from 'devextreme-react/data-grid';
import DropDownBox, { DropDownBoxTypes } from 'devextreme-react/drop-down-box';
import DataSource from 'devextreme/data/data_source';
import CustomStore from 'devextreme/data/custom_store';
import { SysI_Estudios } from '../../../types/types.estudios';
import { Rpm_PerfilesEstudioss } from '../../../types/types.estudios';

export const ModalStudysByProfiles = ({ visible, setVisible, IdPerfil, Perfil, Estudios }: { visible: boolean; setVisible: (value: boolean) => void; IdPerfil: number; Perfil: string; Estudios: SysI_Estudios[] }) => {
  const { getStudiesbyProfiles, newProfileStudy, setProfileStudy, deleteProfileStudy } = useApiConfiguration();
  const { isMedium, isSmall } = useScreenSize();
  const [gridBoxValue, setGridBoxValue] = useState([2]);
  const [isGridBoxOpened, setIsGridBoxOpened] = useState(false);
  const ownerLabel = { 'aria-label': 'Owner' };
  const dataRef = useRef<DataGrid>(null);
  const dataRefs = useRef<DataGrid>(null);

  const customData = useMemo(() => {
    return new CustomStore({
      key: 'Rpe_Id',
      load() {
        return getStudiesbyProfiles(IdPerfil)
          .then((res) => ({
            data: res,
            totalCount: res.totalCount,
            summary: res.summary,
            groupCount: res.groupCount,
          }))
          .catch(() => {
            throw new Error('Error de carga de datos');
          });
      },
      update: (key, values) => {
        return setProfileStudy({ RpmEstudio: values, IdRpm: key })
          .then((res) => {
            if (res === 107) {
              dataRef.current?.instance.refresh();
            }
          })
          .catch((err) => {
            throw new Error(err);
          });
      },
      remove: (key) => {
        return deleteProfileStudy({ IdRpm: key }).then((res) => {
          if (res === 107) {
            dataRef.current?.instance.refresh();
          }
        });
      },
    });
  }, [IdPerfil]);

  const customDataSrc = new DataSource({
    store: customData,
    reshapeOnPush: true,
  });

  const handleVisible = useCallback(() => {
    setVisible(false);
  }, []);

  const dataGridOnSelectionChanged = useCallback((e: { selectedRowKeys: any }) => {
    setGridBoxValue(e.selectedRowKeys);
    setIsGridBoxOpened(false);
  }, []);

  const handleConfigureClick = useCallback(
    (e) => {
      const { data }: { data: SysI_Estudios } = e.row;
      const updatedDataRpm: Rpm_PerfilesEstudioss = {
        Rpe_Id: 0,
        Rpe_Pfe_Id: IdPerfil,
        Rpe_Es_Id: data.Es_Id,
        Rpe_OrdenImpresion: 1,
      };
      newProfileStudy({ RpmEstudio: updatedDataRpm }).then((res) => {
        if (res === 105) {
          dataRef.current?.instance.refresh();
        }
      });
      setIsGridBoxOpened(false);
    },
    [Estudios]
  );

  const dataGridRender = useCallback(
    () => (
      <DataGrid key={Estudios.length} dataSource={Estudios} ref={dataRefs} hoverStateEnabled={true} showBorders={true} selectedRowKeys={gridBoxValue} onSelectionChanged={dataGridOnSelectionChanged} height='100%'>
        <Selection mode='single' />
        <Scrolling mode='virtual' />
        <Paging enabled={true} />
        <FilterRow visible={true} applyFilter='auto' />
        <Column dataField='Es_Id' caption='ID' width={100} alignment='center' />
        <Column dataField='Es_Nombre' caption='ESTUDIO' alignment='left' />
        <Column dataField='Es_Abreviatura' caption='ABREVIATURA' width={120} alignment='center' />
        <Column type='buttons' caption='ACCIÓN'>
          <Butt hint='Configurar' icon='plus' visible={true} disabled={false} onClick={handleConfigureClick} />
        </Column>
      </DataGrid>
    ),
    [gridBoxValue, dataGridOnSelectionChanged]
  );

  const gridBoxDisplayExpr = (item: { An_Id: any; An_Nombre: any }) => item && `${item.An_Nombre} <${item.An_Id}>`;

  const handleSelectedData = useCallback((e: DropDownBoxTypes.ValueChangedEvent) => {
    setGridBoxValue(e.value);
  }, []);

  const onGridBoxOpened = useCallback((e: DropDownBoxTypes.OptionChangedEvent) => {
    if (e.name === 'opened') {
      setIsGridBoxOpened(e.value);
    }
  }, []);

  return (
    <Popup width={1200} height={'auto'} fullScreen={isMedium || isSmall} visible={visible} onHidden={handleVisible} title={IdPerfil + ' - ' + Perfil} showTitle={true} showCloseButton={true}>
      <div>
        <DropDownBox dataSource={Estudios} value={gridBoxValue} opened={isGridBoxOpened} valueExpr={'Es_Id'} displayExpr={gridBoxDisplayExpr} deferRendering={false} inputAttr={ownerLabel} placeholder='ESTUDIOS' showClearButton={true} onValueChanged={handleSelectedData} onOptionChanged={onGridBoxOpened} contentRender={dataGridRender} />
        <br></br>
        <DataGrid className='grid' dataSource={customDataSrc} ref={dataRef} hoverStateEnabled={true} height='auto' repaintChangesOnly={true} highlightChanges={true} rowAlternationEnabled={true} showColumnLines={true}>
          <Scrolling columnRenderingMode='virtual' />
          <Sorting mode='multiple' />
          <Selection mode='single' />
          <KeyboardNavigation editOnKeyPress={true} enterKeyAction='startEdit' enterKeyDirection='column' />
          <Paging enabled={false} />
          <StateStoring enabled={true} type='custom' />
          <Editing mode='form' allowUpdating={true} allowDeleting={true} selectTextOnEditStart={true} texts={{ saveRowChanges: 'Guardar', cancelRowChanges: 'Cancelar', deleteRow: 'Eliminar' }} />
          <Column allowGrouping={false} allowSorting={false} caption='ID' allowEditing={false} visible={true} dataField='SysI_Estudios.Es_Id' width={50} alignment='center' name='Es_Id' />
          <Column allowGrouping={false} caption='ESTUDIO' visible={true} allowEditing={false} dataField='SysI_Estudios.Es_Nombre' alignment='left' />
          <Column allowGrouping={false} caption='ABREVIATURA' allowEditing={false} allowSorting={false} dataField='SysI_Estudios.Es_Abreviatura' width={120} alignment='center' />
          <Column allowGrouping={false} caption='ORDEN' allowEditing={true} allowSorting={false} dataField='Rpe_OrdenImpresion' width={120} alignment='center' />
          <Column type='buttons' caption={'ACCIÓN'} width={150}>
            <Butt name='edit' />
            <Butt name='delete' />
          </Column>
        </DataGrid>
      </div>
    </Popup>
  );
};
